import { ThemeProvider } from "@mui/material";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { PageWrapper } from "@src/appV2/redesign/components/PageWrapper";
import { StickyScrollPageHeader } from "@src/appV2/redesign/components/StickyScrollPageHeader";
import { getTheme } from "@src/appV2/redesign/system/ui-theme";
import { useRef } from "react";

export function LimitedAccessInfoPage() {
  const scrollRef = useRef<HTMLDivElement>(null);

  useLogEffect(APP_V2_USER_EVENTS.LIMITED_ACCESS_INFO_PAGE_VIEWED);

  return (
    <ThemeProvider theme={getTheme()}>
      <PageWrapper ref={scrollRef} variant="tertiary">
        <StickyScrollPageHeader
          title="Limited Access"
          scrollContainerRef={scrollRef}
          headerVariant="tertiary"
        />
      </PageWrapper>
    </ThemeProvider>
  );
}
